export const T = {
  en_GB: {
    // Results
    status: "Status",
    verified: "Verified",
    notVerified: "Not Verified",
    nameLabel: "Name:",
    birthLabel: "Birth:",
    countryLabel: "Country:",
    expiresLabel: "Expires:",
    rejectReasons: "Reject Reasons:",
  },
  nb_NO: {
    // Results
    status: "Status",
    verified: "Verifisert",
    notVerified: "Ikke verifisert",
    nameLabel: "Navn:",
    birthLabel: "Fødsel:",
    countryLabel: "Land:",
    expiresLabel: "Utløper:",
    rejectReasons: "Avvisningsårsaker:",
  },
} as const;
